export const AI_NAME = 'Lia';
